// @flow

import styled from 'styled-components';
import type { Theme } from '../../../types';

export default styled<any, Theme>('div')`
  color: ${props => props.theme.form.title};
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1.875rem;
`;
